import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";
import { Briefcase, FolderKanban, Home as HomeIcon, MailIcon } from "lucide-react";

export default function AdminOverview() {
  const [counts, setCounts] = useState({ services: 0, projects: 0 });

  useEffect(() => {
    Promise.all([api.get("/services"), api.get("/projects")])
      .then(([s, p]) => setCounts({ services: s.data.length, projects: p.data.length }))
      .catch(() => {});
  }, []);

  const cards = [
    { label: "Services", value: counts.services, icon: Briefcase, to: "/dashboard/services" },
    { label: "Projects", value: counts.projects, icon: FolderKanban, to: "/dashboard/portfolio" },
    { label: "Home / Hero", value: "Edit", icon: HomeIcon, to: "/dashboard/home" },
    { label: "Contact info", value: "Edit", icon: MailIcon, to: "/dashboard/contact" },
  ];

  return (
    <div data-testid="admin-overview">
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-fuchsia-400">Dashboard</p>
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-white md:text-4xl">
          Welcome back to <span className="gradient-text">Creative Tribe.</span>
        </h1>
        <p className="mt-3 text-white/60">Manage your website content from one place.</p>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            className="group rounded-2xl border border-white/10 bg-[#131B2F] p-6 hover-lift"
            data-testid={`overview-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="flex items-center justify-between">
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/5">
                <c.icon size={18} className="text-fuchsia-400" />
              </div>
              <span className="text-xs text-white/40 group-hover:text-white">→</span>
            </div>
            <div className="mt-6 text-3xl font-bold text-white">{c.value}</div>
            <div className="mt-1 text-sm text-white/60">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-10 rounded-2xl border border-white/10 bg-[#131B2F] p-8">
        <h3 className="text-lg font-semibold text-white">Quick tips</h3>
        <ul className="mt-4 space-y-2 text-sm text-white/70">
          <li>• Edit your home hero headline from the Home / Hero tab.</li>
          <li>• Add, edit or delete services and portfolio projects anytime — changes go live instantly.</li>
          <li>• Update your contact email and phone from the Contact info tab.</li>
        </ul>
      </div>
    </div>
  );
}
